import { connect } from 'react-redux';
import { FrameworkActionCreator, CustomerActionCreator, AppointmentActionCreator, VehiclesActionCreator, RepairOrdersActionCreator } from 'src/store/states';
import Login from 'src/components/Login/Login';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    viewMode: state.Framework.viewMode,
    custInfo: state.Customer!['Customer'],
    errMsg: state.Customer!.errMsg,
    profileNum: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    theme: state.Framework.theme,
    sessionGUID: state.Framework.sessionId ?? '',
    loadAppt: state.Framework.loadAppt,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    toyLexLoginSent: state.Framework.toyLexLoginSent,
    identityVerified: state.Customer.identityVerified ?? false,
    verifyingIdentity: state.Customer.verifyingIdentity,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    locale: state.Framework.locale,
    specData: state.Specs.specs,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    myGMRewardsLaunched: state.Specs.specs?.myGMRewardsLaunched,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    pushToLeftPane: FrameworkActionCreator.pushToLeftPane,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    onLogin: CustomerActionCreator.LoginCustomer,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    clearError: CustomerActionCreator.CustomerClearError,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    getVehicles: VehiclesActionCreator.GetVehicles,
    fetchROs: RepairOrdersActionCreator.FetchROs,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    getCustAppts: AppointmentActionCreator.GetCustAppts,
    ClearTokenData: FrameworkActionCreator.ClearTokenData,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    sendResetEmail: CustomerActionCreator.SendResetEmail,
    setToyLexLoginSent: FrameworkActionCreator.SetToyLexLogin,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    setApptHistId: AppointmentActionCreator.SetApptHistId,
    setVehSelReset: FrameworkActionCreator.SetVehSelReset,
    gmMemberSearch: CustomerActionCreator.GMMemberSearch,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Login);